// Modern Icons using Lucide React
import { 
  LayoutDashboard, 
  Bot, 
  Megaphone, 
  PhoneCall, 
  History, 
  Settings, 
  CreditCard,
  Plus,
  Pencil,
  Trash2,
  X,
  Globe,
  Wrench,
  LogOut,
  Home,
  Users,
  Phone,
  FileText,
  Mail,
  MessageSquare,
  Calendar,
  Webhook,
  ChevronRight,
  ChevronDown,
  Check,
  AlertCircle,
  Clock,
  Play,
  Pause,
  Upload,
  Download,
  Search,
  Filter,
  MoreVertical,
  ExternalLink,
  Copy,
  RefreshCw,
  BarChart3
} from 'lucide-react';

// Export Icons object for backward compatibility
export const Icons = {
  // Sidebar icons
  Home: () => <LayoutDashboard className="w-5 h-5" />,
  Dashboard: () => <LayoutDashboard className="w-5 h-5" />,
  Users: () => <Bot className="w-5 h-5" />,
  Agents: () => <Bot className="w-5 h-5" />,
  Campaigns: () => <Megaphone className="w-5 h-5" />,
  Phone: () => <PhoneCall className="w-5 h-5" />,
  Queue: () => <PhoneCall className="w-5 h-5" />,
  Document: () => <History className="w-5 h-5" />,
  History: () => <History className="w-5 h-5" />,
  Settings: () => <Settings className="w-5 h-5" />,
  CreditCard: () => <CreditCard className="w-5 h-5" />,
  Billing: () => <CreditCard className="w-5 h-5" />,
  Usage: () => <BarChart3 className="w-5 h-5" />,
  
  // Action icons
  Plus: () => <Plus className="w-5 h-5" />,
  Edit: () => <Pencil className="w-4 h-4" />,
  Trash: () => <Trash2 className="w-4 h-4" />,
  X: () => <X className="w-5 h-5" />,
  Logout: () => <LogOut className="w-5 h-5" />,
  
  // Tool icons
  Bot: () => <Bot className="w-6 h-6" />,
  Globe: () => <Globe className="w-5 h-5" />,
  Tool: () => <Wrench className="w-5 h-5" />,
  
  // Status icons
  Check: () => <Check className="w-5 h-5" />,
  Alert: () => <AlertCircle className="w-5 h-5" />,
  Clock: () => <Clock className="w-5 h-5" />,
  Play: () => <Play className="w-5 h-5" />,
  Pause: () => <Pause className="w-5 h-5" />,
  
  // Misc icons
  Upload: () => <Upload className="w-5 h-5" />,
  Download: () => <Download className="w-5 h-5" />,
  Search: () => <Search className="w-5 h-5" />,
  Filter: () => <Filter className="w-5 h-5" />,
  More: () => <MoreVertical className="w-5 h-5" />,
  External: () => <ExternalLink className="w-4 h-4" />,
  Copy: () => <Copy className="w-4 h-4" />,
  Refresh: () => <RefreshCw className="w-5 h-5" />,
  ChevronRight: () => <ChevronRight className="w-5 h-5" />,
  ChevronDown: () => <ChevronDown className="w-5 h-5" />,
  
  // Google icon (keep original for branding)
  Google: () => (
    <svg className="w-5 h-5" viewBox="0 0 24 24">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
  ),
};

// Also export individual icons for direct use
export {
  LayoutDashboard,
  Bot,
  Megaphone,
  PhoneCall,
  History,
  Settings,
  CreditCard,
  Plus,
  Pencil,
  Trash2,
  X,
  Globe,
  Wrench,
  LogOut,
  Home,
  Users,
  Phone,
  FileText,
  Mail,
  MessageSquare,
  Calendar,
  Webhook,
  ChevronRight,
  ChevronDown,
  Check,
  AlertCircle,
  Clock,
  Play,
  Pause,
  Upload,
  Download,
  Search,
  Filter,
  MoreVertical,
  ExternalLink,
  Copy,
  RefreshCw
};
